@use '../../styling/buttons.scss' as *;
@use '../../styling/colors.scss' as *;

.SmallButton {
  @extend %button;

  min-width: 1px;
  padding: 4px 8px;
  height: 26px;
  column-gap: 6px;

  // overwrite the secondary style without border
  &.secondary {
    color: $theme-color-text;
    border: none !important;

    &:disabled {
      color: $color-grey-disabled;
      opacity: 1;
    }
  }
}
